<template lang="pug">
.crud()
  .container-fluid
    vm-row.heading(vm-w="12")
      vm-col(vm-type="flex" vm-align="center" vm-lg=6 vm-sm=6)
        div
          h2 {{ $t('strings.purchase_order_details') }}:
          span {{ $t('strings.description', {attribute: $t('strings.products')}) }}
        div(style="display:none;")
          vm-button(type="default" icon="list")
          vm-button(type="default" icon="grid" color="rgba(var(--gray),1)")
      vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-lg=6 vm-sm=6)
        div
          vm-tooltip(:text="$t('strings.options')" delay=".5s")
            vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
              vm-button(type="border" icon="more-horizotnal" color="#afbbc6")
              vm-dropdown-menu
                vm-dropdown-item.d-flex.justify-content-between(@click="exportViewPurchaseOrderProducts")
                  vm-icon(icon="download-outline")
                  slot &nbsp;{{ $t('strings.export') }}
    vm-row(vm-w="12")
      vm-col.card(vm-sm=12)
        vm-table(max-height="350px" :data="purchaseOrderProducts")
          template(slot="header")
            .d-flex.justify-content-between
              vm-input(ref="search" icon="search" size="small"  v-model="filters.where.param" @keyup.enter="applyFilter(filters)" width="300px")
              .d-flex.justify-content-between(@click="loadCatalogsFilters()")
                vm-tooltip(:text="$t('strings.filters')" delay=".5s")
                  vm-dropdown(ref="dropdown" vm-custom-content vm-trigger-click vm-trigger-outside-click)
                    vm-button(type="default" icon="funnel-outline" size="small")

                    vm-dropdown-menu(class="filters")
                      .heading.d-flex.justify-content-between
                        h4 {{ $t('strings.filters') }}
                        vm-button(type="flat" size="small" @click="clearFilter") {{ $t('strings.clear') }}
                      vm-select.filter(:placeholder='$t("strings.multiple")' :label='$t("purchase_order_details.status_id")' multiple autocomplete v-model="filters.whereIn.status_id" @change="$emit('filter', filters)")
                        vm-select-item(:key='index', :value='item.id', :text="$t('purchase_order_details.'+ item.id)", v-for='item,index in purchaseOrderDetailStatuses')
                      .filter.d-flex
                        vm-button(@click="applyFilter(filters)") {{ $t('strings.apply') }}
          template(slot="thead")
            vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('purchase_order_details.' + column) }}
          template(slot-scope="{data}")
            vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
              vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
                  slot(v-if="column == 'purchase_order_created_at'")  {{data[indextr][column] | moment("DD MMMM YYYY") }}
                  slot(v-if="column == 'quantity' || column == 'active_shipment_quantity' || column == 'pending_amount_to_ship' || column == 'pending_amount_to_be_received'") {{ data[indextr][column] | currency('') }}
                  slot(v-if="column == 'product_code_display' || column == 'product_display' || column == 'purchase_order_manual_folio' || column == 'purchase_order_folio'") {{data[indextr][column]}}
                  vm-status-indicator(v-if="column == 'status_id'" :pulse="data[indextr]['status_id'] !== 'Activo'" :color="colorStatus(data[indextr]['status_id'])") {{ $t('purchase_order_details.'+ data[indextr]['status_id']) }}
        vm-pagination(:total="pagination.totalPages" v-model="currentPage" goto)
</template>

<script>
import ViewMixinMaster1 from '@/mixins/ViewMixinMaster1'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('PurchaseOrderProducts')

export default {
  name: 'ViewPurchaseOrdersProducts',
  components: {},
  mixins: [ViewMixinMaster1],
  data: () => ({
    columns: [
      'purchase_order_manual_folio',
      'product_code_display',
      'product_display',
      'quantity',
      'active_shipment_quantity',
      'pending_amount_to_ship',
      'pending_amount_to_be_received',
      'status_id',
      'purchase_order_created_at',
      'purchase_order_folio'
    ],
    columnsOrderBy: ['name', 'email'],
    attributeModal: 'name',
    status: [
      {
        value: 1,
        color: 'warning'
      },
      {
        value: 2,
        color: 'danger'
      },
      {
        value: 3,
        color: 'danger'
      }
    ],
    filters: {
      where: {
        product: {
          code: ''
        },
        param: ''
      },
      whereIn: {
        status_id: []
      },
      whereBetween: {
      },
      betweenDates: {
        created_at: []
      },
      orderBy: ''
    }
  }),
  async created () {
    await this.loadPurchaseOrderDetailStatuses()
  },
  computed: {
    ...mapGetters(['purchaseOrderProducts', 'catalog', 'pagination', 'filterParams', 'purchaseOrderDetailStatuses'])
  },
  methods: {
    ...mapActions([
      'loadRecords',
      'loadCatalog',
      'exportRecords',
      'applyFilter',
      'clearFilter',
      'getPurchaseOrderDetailStatuses'
    ]),
    async loadPurchaseOrderDetailStatuses () {
      if (this.purchaseOrderDetailStatuses.length === 0) await this.getPurchaseOrderDetailStatuses()
    },
    exportViewPurchaseOrderProducts () {
      this.exportRecords()
    }
  }
}
</script>

<style lang="scss">
.filters {
  .filter {
    padding: 5px 10px;
    width: 250px;
  }
}
.con-vm-tooltip {
  display: inline-block;
  position: relative;
}
.con-tablex.vm-table--content {
  overflow: visible !important;
}
thead.vm-table--thead-table {
  position: sticky;
  top: 0px;
  z-index: 999;
  background-color: white;
}
.vm-table--header {
  padding: 10px;
  span:nth-child(1) {
    width: 100%;
  }
  .input-select-con {
    span {
      width: auto !important;
    }
  }
  .justify-content-between {
    div:last-child {
      .vm-button {
        margin: 0 3px;
      }
      .vm-con-dropdown {
        float: left;
      }
      .con-select {
        display: inline-block;
        input {
          height: 32px;
        }
      }
    }
  }
}
</style>
